import { call, put, takeLatest } from 'redux-saga/effects';
import { projectService } from './project.service';
import {
  GET_PROJECTS, GET_PROJECTS_SUCCESS,
  GET_PROJECT, GET_PROJECT_SUCCESS,
  CREATE_PROJECT, CREATE_PROJECT_SUCCESS,
  EDIT_PROJECT, EDIT_PROJECT_SUCCESS,
  DELETE_PROJECT, DELETE_PROJECT_SUCCESS,
  ADD_MEMBER, ADD_MEMBER_SUCCESS,
  REMOVE_MEMBER, REMOVE_MEMBER_SUCCESS,
} from './project.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getProjectsSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(projectService.getProjects, payload);
    yield put({ type: GET_PROJECTS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* getProjectSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(projectService.getProject, payload);
    yield put({ type: GET_PROJECT_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* createProjectSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(projectService.createProject, payload);
    yield put({ type: CREATE_PROJECT_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* editProjectSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(projectService.editProject, payload.id, payload.data);
    yield put({ type: EDIT_PROJECT_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* deleteProjectSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    yield call(projectService.deleteProject, payload);
    yield put({ type: DELETE_PROJECT_SUCCESS, payload });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* addMemberSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(projectService.addMember, payload.projectId, payload.userId);
    yield put({ type: ADD_MEMBER_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* removeMemberSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(projectService.removeMember, payload.projectId, payload.userId);
    yield put({ type: REMOVE_MEMBER_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchProjects() {
  yield takeLatest(GET_PROJECTS, getProjectsSaga);
  yield takeLatest(GET_PROJECT, getProjectSaga);
  yield takeLatest(CREATE_PROJECT, createProjectSaga);
  yield takeLatest(EDIT_PROJECT, editProjectSaga);
  yield takeLatest(DELETE_PROJECT, deleteProjectSaga);
  yield takeLatest(ADD_MEMBER, addMemberSaga);
  yield takeLatest(REMOVE_MEMBER, removeMemberSaga);
}
